import React, { useMemo, useState } from 'react';
import { Field, Area, Check, useEmit } from './fields';

/**
 * Emits: { electricIsolation (bool), gasIsolation (bool), otherDetails (string) }
 * NOTE: the V2 version never wired onDataChange — this rebuild fixes that so the
 * data actually reaches the submission payload.
 */
const CriticalWorkRequirements = ({ onDataChange }) => {
    const [electric, setElectric] = useState(false);
    const [gas, setGas] = useState(false);
    const [other, setOther] = useState(false);
    const [electricDetails, setElectricDetails] = useState('');
    const [gasDetails, setGasDetails] = useState('');
    const [otherDetails, setOtherDetails] = useState('');

    const data = useMemo(() => {
        const parts = [];
        if (electric && electricDetails) parts.push(`Electric: ${electricDetails}`);
        if (gas && gasDetails) parts.push(`Gas: ${gasDetails}`);
        if (other && otherDetails) parts.push(otherDetails);
        return { electricIsolation: electric, gasIsolation: gas, otherDetails: parts.join(' | ') };
    }, [electric, gas, other, electricDetails, gasDetails, otherDetails]);
    useEmit(data, onDataChange);

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Critical Work Requirements</h6></div>
            <div className="v3-wp-checks">
                <Check id="cw-elec" label="Electric Isolation" checked={electric} onChange={setElectric} />
                <Check id="cw-gas" label="Gas Isolation" checked={gas} onChange={setGas} />
                <Check id="cw-other" label="Other" checked={other} onChange={setOther} />
            </div>
            {(electric || gas || other) && (
                <div className="v3-wp-grid" style={{ marginTop: 12 }}>
                    {electric && <Field label="Electric Isolation Details" full><Area value={electricDetails} onChange={setElectricDetails} rows={2} /></Field>}
                    {gas && <Field label="Gas Isolation Details" full><Area value={gasDetails} onChange={setGasDetails} rows={2} /></Field>}
                    {other && <Field label="Other Details" full><Area value={otherDetails} onChange={setOtherDetails} rows={2} /></Field>}
                </div>
            )}
        </div>
    );
};

export default CriticalWorkRequirements;
